import { useSearchLocationPopularDestinations } from '@/constants/search';
import { usePopularParks } from '@/hooks/usePopularParks';

export const usePopularDestinations = () => {
  const searchLocationPopularDestinations = useSearchLocationPopularDestinations();
  const parksResponse = usePopularParks(searchLocationPopularDestinations);

  const popularDestinationsByLocation = parksResponse?.map(park => ({
    label: park?.label,
    sublabel: park?.sublabel,
    value: park?.value,
    groupName: 'popularDestinations',
  }));

  return popularDestinationsByLocation.length
    ? popularDestinationsByLocation
    : searchLocationPopularDestinations;
};
